<div class="modify-reference-values">
  <div class="dropdown">
    <mat-form-field>
      <mat-select
        [(value)]="buildingTypeName"
        disableOptionCentering
        panelClass="myPanelClass"
        [formControl]="buildingType"
        placeholder="{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.objectTypePlaceholderText' | translate }}"
      >
        <mat-option *ngFor="let buildingType of comparisonValues" [value]="buildingType.buildingTypeName" (click)="setFormValues(buildingType)">
          {{ buildingType.buildingTypeName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <h5 class="message">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.messageText' | translate }}</h5>

  <table class="table" aria-describedby="efficiency-analysis">
    <tr>
      <th scope="col" class="header label1">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.header1Text' | translate }}</th>
      <th scope="col" class="header label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.header2Text' | translate }}</th>
      <th scope="col" class="header label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.header3Text' | translate }}</th>
    </tr>

    <tr>
      <td class="input-label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.label1Text' | translate }}</td>
      <td class="electricity-col">
        <div class="input-group">
          <input
            class="input"
            [formControl]="refValElectricity"
            placeholder="0"
            maxlength="4"
            (focus)="focus('refValElectricity')"
            (blur)="blur('refValElectricity')"
            (keypress)="numberOnly($event)"
          />
          <label class="unit label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.unitLabelText' | translate }}</label>
        </div>
      </td>
      <td class="heat-col">
        <div class="input-group">
          <input
            class="input"
            [formControl]="refValHeat"
            placeholder="0"
            maxlength="4"
            (focus)="focus('refValHeat')"
            (blur)="blur('refValHeat')"
            (keypress)="numberOnly($event)"
          />
          <label class="unit label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.unitLabelText' | translate }}</label>
        </div>
      </td>
    </tr>

    <tr>
      <td class="input-label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.label2Text' | translate }}</td>
      <td class="electricity-col">
        <div class="input-group">
          <input
            class="input"
            [formControl]="averageElectricity"
            placeholder="0"
            maxlength="4"
            (focus)="focus('averageElectricity')"
            (blur)="blur('averageElectricity')"
            (keypress)="numberOnly($event)"
          />
          <label class="unit label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.unitLabelText' | translate }}</label>
        </div>
      </td>
      <td class="heat-col">
        <div class="input-group">
          <input
            class="input"
            [formControl]="averageHeat"
            placeholder="0"
            maxlength="4"
            (focus)="focus('averageHeat')"
            (blur)="blur('averageHeat')"
            (keypress)="numberOnly($event)"
          />
          <label class="unit label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.unitLabelText' | translate }}</label>
        </div>
      </td>
    </tr>

    <tr>
      <td class="input-label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.label3Text' | translate }}</td>
      <td class="electricity-col">
        <div class="input-group">
          <input
            class="input"
            [formControl]="maxScaleElectricity"
            placeholder="0"
            maxlength="4"
            (focus)="focus('maxScaleElectricity')"
            (blur)="blur('maxScaleElectricity')"
            (keypress)="numberOnly($event)"
          />
          <label class="unit label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.unitLabelText' | translate }}</label>
        </div>
      </td>
      <td class="heat-col">
        <div class="input-group">
          <input
            class="input"
            [formControl]="maxScaleHeat"
            placeholder="0"
            maxlength="4"
            (focus)="focus('maxScaleHeat')"
            (blur)="blur('maxScaleHeat')"
            (keypress)="numberOnly($event)"
          />
          <label class="unit label">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.unitLabelText' | translate }}</label>
        </div>
      </td>
    </tr>
  </table>

  <div class="btn-container">
    <div class="buttons">
      <button class="btn btn-outline-secondary" (click)="cancel()">
        {{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.cancel' | translate }}
      </button>
      <button class="btn btn-outline-primary" (click)="openSaveConfirmationDialog()" [disabled]="checkButtonStatus()">
        {{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.save' | translate }}
      </button>
    </div>
  </div>
</div>
